import axios from 'axios';
import apiConstants from '../config/index';

const JSON_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

class Api {
  static get(url: string, responseType: any) {
    return this.xhr(url, null, 'get', {}, responseType);
  }

  static async getSurcharge(url: string) {
    const config = {
      headers: {
        'developer-id': apiConstants.REACT_APP_DEVELOPER_ID,
      },
    };
    const res = await axios.get(url, config);
    return res;
  }

  static post(url: any, params: any) {
    return this.xhr(url, params, 'post', JSON_HEADERS, null);
  }

  static xhr(url: string, params: any, method: any, headers: object, responseType: any) {
    return new Promise((resolve) => {
      const options = {
        url,
        data: (params === null) ? null : JSON.stringify(params),
        method,
        headers,
        responseType,
      };

      if (responseType) {
        options.responseType = responseType;
      }

      axios(options).then((resp) => {
        resolve(resp);
      }).catch((err) => {
        resolve(err.response);
      });
    });
  }
}

export default Api;
